<script setup lang="ts">
import { useDeviceConnectionState } from './utils/useDeviceConnectionState';
import { I18nKey } from '@/utils/typings';
import { IotDeviceStateOfUse } from '@/api/generator';
import { computed } from 'vue';

const props = defineProps<{
  value?: IotDeviceStateOfUse;
}>();

const info = useDeviceConnectionState(computed(() => props.value));
</script>

<template>
  <div class="device-connection-state d-flex align-center">
    <v-sheet
      color="surface"
      class="icon-wrapper d-inline-flex justify-center align-center"
      rounded="sm"
    >
      <v-icon :color="info.color" size="16">{{ info.icon }}</v-icon>
    </v-sheet>
    <div>{{ $t(info.label as I18nKey) }}</div>
  </div>
</template>

<style lang="scss" scoped>
.device-connection-state {
  padding: 2px;
  gap: 4px;
  .icon-wrapper {
    width: 22px;
    height: 22px;
  }
}
</style>
